export { user } from './user'
export { escala } from './escalas'
export { pesquisa } from './pesquisa_aulas'
export { receitas_despesas } from './receitas_despesas'
export { vuetableState } from './vuetableState'
export * from './emendas_parlamentares'
export * from './eleicoes_conselho'
export * from './plano_governo'
export * from './localizacao_unidades'



// WEBPACK FOOTER //
// ./src/store/modules/index.js